export default __webpack_public_path__ + "static/kossLogo-47f192a25a9c7fa1c009cb9d4cf25f24.png";